export const getGeneratedBatchCode = (prefix = '') => {
    const date = new Date();

    return prefix +
        date.getDate().toString().padStart(2, '0') +
        (date.getMonth() + 1).toString().padStart(2, '0') +
        date.getFullYear().toString() +
        date.getHours().toString().padStart(2, '0') +
        date.getMinutes().toString().padStart(2, '0') +
        date.getSeconds().toString().padStart(2, '0');
};
